import { selectAllLayouts } from "../selectors/widgetDashboard";
import { useSelector } from "react-redux";
import { selectActiveLayoutId } from '../selectors/home';
import { WidgetDashboardConfig } from '../components/widgetDashboard/widgetDashboard.interface';


const useSelectActiveLayout = (): [string, WidgetDashboardConfig] => {
    const allLayouts = useSelector(selectAllLayouts)
    const id = useSelector(selectActiveLayoutId)
    return [id, allLayouts[id]]
}

export default useSelectActiveLayout;